/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundHistoryFundDto
 */
export interface FundHistoryFundDto {
  /**
   *
   * @type {string}
   * @memberof FundHistoryFundDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundHistoryFundDto
   */
  name: string;
}

export function FundHistoryFundDtoFromJSON(json: any): FundHistoryFundDto {
  return FundHistoryFundDtoFromJSONTyped(json, false);
}

export function FundHistoryFundDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundHistoryFundDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function FundHistoryFundDtoToJSON(value?: FundHistoryFundDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
